import { environment } from './../../../environments/environment';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mytimesheet',
  templateUrl: './mytimesheet.component.html',
  styleUrls: ['./mytimesheet.component.css']
})
export class MytimesheetComponent implements OnInit {

   _agent = {};

  constructor() {
    const uservo = JSON.parse(localStorage.getItem(environment.oauth.remoteUser));
    if (uservo) {
      this._agent = {
        id: uservo.id,
        username: uservo.userName,
        firstName: uservo.firstName,
        lastName: uservo.lastName,
        name : uservo.firstName + ' ' + uservo.lastName + ' [' + uservo.userName + ']',
        periods: [{start: null, end: null}]
      };
    }
  }

  ngOnInit() {
    console.log('this is a model myTimesheet');

  }

}



// WEBPACK FOOTER //
// ./src/app/view/mytimesheet/mytimesheet.component.ts